var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViuzzV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 308.8 534.6",
    style: {
      enableBackground: "new 0 0 308.8 534.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -62.1445,
    y1: 703.3112,
    x2: 469.718,
    y2: 81.1319,
    gradientTransform: "matrix(1 0 0 -1 1.546141e-11 842.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.1024e-7,
    style: {
      stopColor: "#F08316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4183,
    style: {
      stopColor: "#E62F26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M149.5,333.1l-0.2-1.6c-0.3-4.4-0.6-8.8-1-13.2c-6.1-73.2-25.8-142.6-56.5-205.8c0,0,0,0,0,0 c-0.7-1.4-1.3-2.8-2-4.2c-0.3-0.6-0.6-1.2-0.9-1.8c-0.7-1.3-1.4-2.5-2.2-3.7c0-0.1-0.1-0.1-0.1-0.2c-7.2-11-19-18.9-33.1-20.8 C27.7,78.3,3.9,96.4,0.4,122.2c-1,7.6-0.2,15,2.2,21.9c0,0,0,0.1,0.1,0.2c0.7,1.4,1.3,2.8,1.9,4.2c0.5,1,0.9,1.9,1.3,2.9 c0,0.1,0.1,0.1,0.1,0.2c1.1,2.3,2.1,4.7,3.1,7c0.6,1.4,1.2,2.8,1.8,4.3c1,2.4,2,4.8,3,7.3c0.2,0.5,0.4,1,0.7,1.6c1.2,3,2.3,6,3.5,9 c0.1,0.4,0.3,0.7,0.4,1.1c1.2,3.1,2.3,6.2,3.5,9.3c0.3,0.8,0.6,1.6,0.9,2.4c1.1,3.2,2.2,6.4,3.3,9.7c0.9,2.6,1.7,5.1,2.5,7.7 c0.8,2.3,1.5,4.6,2.2,7c0.9,3,1.8,6,2.6,9c0.9,3,1.8,6.1,2.6,9.1c0.7,2.4,1.3,4.7,1.9,7.1c0.6,2,1,4.1,1.6,6.1 c1.4,5.7,2.8,11.5,3.9,17.3c0.4,1.9,0.8,3.7,1.2,5.6c0.6,2.9,1.2,5.7,1.7,8.6c11.1,59.2,13.2,121.1,5,184c-0.1,0.9-0.2,1.8-0.3,2.6 c-0.2,1.2-0.3,2.4-0.5,3.6l0,0l0,0c0,0.2-0.1,0.4-0.1,0.6c0,0,0-0.1,0.1-0.1l-0.6,8.9c0,0,15.5,0.1,16.3-0.7 c0.8-0.8,25.7-19.3,25.7-19.3L151,336.7L149.5,333.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.69,
    y1: 601.4209,
    x2: -205.9885,
    y2: -34.6616,
    gradientTransform: "matrix(1 0 0 -1 1.546141e-11 842.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6714,
    style: {
      stopColor: "#F08316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E62F26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M308.8,130.8v0.5c-0.1,1.5-0.2,3-0.3,4.6c-8.8,135.1-63.4,257.7-148.3,352.4 c-6.9,7.7-28,27.8-28.8,28.8c-8,9.2-19.1,15.9-32.2,17.1c-1.2,0.1-2.3,0.2-3.4,0.2c-24.5,0.5-45.6-18.1-47.9-42.8 c-0.1-1-0.2-2.1-0.2-3.2c0.9-5.6,1.8-11.1,2.6-16.8c1.8-5.3,4.6-10.1,8-14.3c0.1-0.1,0.1-0.1,0.1-0.2c1.3-1.3,2.6-2.7,3.9-4.1 c0.1-0.1,0.1-0.1,0.2-0.2c7.7-8.3,15.1-16.7,22.2-25.4c19.6-23.7,37.4-49,53-75.6c4-6.7,7.8-13.5,11.5-20.4c1.4-2.6,2.8-5.1,4.1-7.7 c31.5-60.7,52.6-127.4,61.3-197.5c0-0.7,0.1-1.3,0.2-2c0-0.2,0-0.4,0.1-0.5c3.1-21,20.2-38,42.3-40c26-2.4,48.9,16.7,51.3,42.6 C308.8,127.9,308.8,129.4,308.8,130.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.0748,
    y1: 799.6645,
    x2: 199.9664,
    y2: 799.6645,
    gradientTransform: "matrix(1 0 0 -1 1.546141e-11 842.1102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2866,
    style: {
      stopColor: "#F08316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E62F26"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M157.5,84.9c23.4,0,42.4-19,42.4-42.4S181,0,157.5,0s-42.4,19-42.4,42.4 S134.1,84.9,157.5,84.9z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViuzzV);
export default __webpack_public_path__ + "static/media/ViuzzV.3f73c93c3d699f404bd279d6e0afc5a7.svg";
export { ForwardRef as ReactComponent };